/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {validateInstrumentLinkErrorCode} from '../api'

export const useMutationValidateInstrumentLinkErrorCode = createReactQueryMutationHook('validateInstrumentLinkErrorCode', validateInstrumentLinkErrorCode)
